export default {
  icon: 'mdi-file-document-outline',
  name: 'Sensors',
  noItems: 'Sensors non disponible',
  fields: {
    id: 'ID',
    valid_nomenclature: 'NCA Valide',
    type: 'Type',
    temperature_meter: 'Sonde Temp',
    meter_property_name: 'Propriété',
    label: 'Libelle',
  },
};
